import { Request } from "@xt/xtbase";

const { XtAxios } = Request;
const URL = "/xt-app/";

export function get_marketTips(config?) {
  return XtAxios.get(URL + "public/market-tips-config", config);
}

export function get_maintainTips(config?) {
  return XtAxios.get(URL + "public/maintain-tips-config", config);
}

export function get_searchMarketHot(config?) {
  return XtAxios.get(URL + "public/search-market/hot", config);
}
